import { render, staticRenderFns } from "./createCategory.vue?vue&type=template&id=08096dc7&scoped=true&"
import script from "./createCategory.vue?vue&type=script&lang=js&"
export * from "./createCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08096dc7",
  null
  
)

export default component.exports